export default __webpack_public_path__ + "static/Web-camera-amazon-main-diagram-DE-4-c399e30f02639e5b71868775bf9cfd92.webp";